module.exports = __webpack_public_path__ + "img/x_white.6661a661.svg";